import { DateTime } from 'luxon';
import { Plugin } from '../model/plugin';
import { Mod } from '../model/tag';
import { imagePlugin } from './image';
import { videoPlugin } from './video';

export const thumbnailPlugin: Plugin = {
  tag: 'plugin/thumbnail',
  name: $localize`⭕️ Thumbnail`,
  config: {
    type: 'plugin',
    default: true,
    proxy: true,
    add: true,
    generated: $localize`Generated by jasper-ui ${DateTime.now().toISO()}`,
    description: $localize`Activates built-in thumbnail support and allows users to add thumbnails to Refs.`,
    aiInstructions: `# plugin/thumbnail
    The thumbnail plugin is installed, which means a thumbnail may/may not be displayed to the left of the title.
    The thumbnail is enabled with the plugin/thumbnail plugin and can be set by either the Ref url or the plugin
    data url. However, if a Ref does not have a thumbnail set, it may inherit a default thumbnail from a Plugin.
    For example, the plugin/thread Plugin has the following icons set:
    \`\`\`json
    icons: [{ thumbnail: $localize\`🧵️\` }],
    \`\`\`
    While the plugin/chat Plugins has this:
    \`\`\`json
    icons: [{ thumbnail: $localize\`💬️\`, order: 1 }],
    \`\`\`
    So if they were on the same Ref, the plugin/chat would take priority and that
    would be the thumbnail.
    `,
    filters: [
      { query: 'plugin/thumbnail', label: $localize`⭕️ thumbnail`, title: $localize`Has Thumbnail`, group: $localize`Plugins 🧰️` },
    ],
    extensions: [...videoPlugin.config!.extensions!, ...imagePlugin.config!.extensions!],
    advancedForm: [{
      key: 'url',
      type: 'image',
      props: {
        label: $localize`URL:`,
      },
    }, {
      key: 'color',
      type: 'color',
      props: {
        label: $localize`Color:`,
      },
    }, {
      key: 'emoji',
      type: 'string',
      props: {
        label: $localize`Emoji:`,
      },
    }, {
      key: 'radius',
      type: 'range',
      defaultValue: 0,
      props: {
        label: $localize`Radius:`,
        min: 0,
        max: 24,
        step: 4,
      },
    }],
  },
  schema: {
    optionalProperties: {
      url: { type: 'string' },
      color: { type: 'string' },
      emoji: { type: 'string' },
      radius: { type: 'int32' },
    },
  },
};

export const thumbnailMod: Mod = {
  plugin: [
    thumbnailPlugin,
  ]
};
